/**
 * @prettier
 */
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { Button } from 'src/components/Button';
import { Dialog } from 'src/components/Dialog';
import { DialogActions } from 'src/components/DialogActions';
import { translate } from 'src/i18n/translate';

export function UnableToCloseCashRegisterDialog({ open, onClose }: Props): React.ReactElement {
    const classes = useStyles();

    return (
        <Dialog open={open} onClose={onClose} title={translate('Close Cash Register')}>
            <p className={classes.bodyText}>{translate('Unable to close the cash register with pending orders')}</p>
            <DialogActions className={classes.buttonsContainer}>
                <Button primary onClick={onClose}>
                    {translate('Accept')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles((theme) => ({
    alertTitleDialog: {
        textAlign: 'center',
        color: theme.palette.primary.main,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(3),
        '& h2': {
            fontFamily: theme.typography.medium,
            fontSize: 28,
        },
    },
    bodyText: {
        fontFamily: theme.typography.medium,
        textAlign: 'center',
        fontSize: 14,
        color: theme.palette.secondary.contrastText,
    },

    buttonsContainer: {
        marginTop: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    acceptButton: {
        fontFamily: theme.typography.semiBold,
        fontSize: 15,
        borderRadius: 15,
        height: 40,
        minWidth: 150,
        textTransform: 'none',
        marginTop: 15,
        [theme.breakpoints.up('md')]: {
            margin: 0,
        },
    },
}));

type Props = {
    open: boolean;
    onClose: any;
};
